export default __webpack_public_path__ + "static/media/Skrymir.b4b16ddb.jpg";